<template>
  <div id="app" :class="{'app-en':isEN=='en'}" @click="clickMk()">
    <router-view/>
	<!-- loading -->
	<div class="modal" v-if="showLoad">
		<div class="modal-bg"></div>
		<div class="modal-content" style="width:100%;left:0;">
			<div class="loadBox ac">
				<div class="load-bg"></div>
				<div class="loadCont">
					<img src="static/images/loading.gif"/>
					<p>{{$t('pleaseWait')}} ...</p>
				</div>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
import '../static/js/howler.min.js'
export default {
  name: 'App',
  data(){
	return{
		showLoad:false,
    isEN:'bur',
    isBgmPlaying: false,
    bgmEnabled: true, // 新增：全局音乐开关
    sounds: {
      bg: null,
    },
	}
  },
  created(){
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
    if(localStorage.getItem('BackgroundMusic')==null){
      localStorage.setItem('BackgroundMusic', 'true');
    }
    this.initHowler()
  },
	methods: {
    initHowler() {
      if (this.sounds.bg) return
      Howler.autoUnlock = true
      Howler.mobileAutoEnable = true
      this.sounds.bg = new Howl({
        src: ['../static/music/bg.mp3'],
        volume: 1.0,
        preload: true,
        loop:true
      })
    },
    clickMk(){
      if (!this.bgmEnabled) return;
      if(this.isBgmPlaying){
        if (!this.sounds.bg.playing()){
          this.sounds.bg.play()
        }
        return;
      }
      if(JSON.parse(localStorage.getItem('BackgroundMusic'))){
        this.startBackgroundMusic();
      }
    },
    handleGlobalClick(event) {
      // 如果点击的是不需要触发音乐的元素，则返回
      if (event.target.closest('.kai')) {
        return;
      }
      console.log('全局点击事件:')
      if (localStorage.getItem('BackgroundMusic') === 'true'){
        this.startBackgroundMusic()
      }
    },
    startBackgroundMusic() {
      if (!this.sounds.bg || this.sounds.bg.playing()) return
      this.sounds.bg.play()
      this.isBgmPlaying = true;
      localStorage.setItem('BackgroundMusic', 'true');
    },
    stopBackgroundMusic(pause=false) {
      if (!this.sounds.bg) return
      if (pause){
        this.sounds.bg.stop()
      }else{
        this.isBgmPlaying = false;
        this.sounds.bg.stop()
        localStorage.setItem('BackgroundMusic', 'false');
      }

    },
		// code判断
		returnCode (data,callback) {
      let queryParams = this.$route.query;
			let code = data.code;
      //callback();
			if(code == 1){
				this.showLoad = false;
				callback();
			}else if(code==101){
				this.showLoad = false;
        this.$router.push({path:'/login',query: {...queryParams}})
			}else{
				this.showLoad = false;
				this.$utils.alertText(data.msg,80);
			}
		},
		loadModal(isShow){
			let that = this;
			that.showLoad = isShow;
		}
	}
}
</script>

<style>
	@import "./style/style.css";
	.modal{position:fixed;top:0;left:0;width:100%;height:100%;z-index:999;}
	.modal-bg{width:100%;height:100%;background:rgba(0,0,0,.5);}
	.modal-content{position:absolute;top:50%;left:50%;transform:translate(0,-50%);}
	.loadCont p{color:#fff;margin:10px 0 0;}
</style>



// WEBPACK FOOTER //
// src/App.vue